"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _NotificationMessage = require("./NotificationMessage.style");
var _Text = _interopRequireDefault(require("../Text"));
const NotificationMessage = _ref => {
  let {
    message
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_NotificationMessage.NotificationWrapper, {
    "data-testid": message
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    type: "Body",
    html: true,
    intlText: message
  }));
};
var _default = exports.default = NotificationMessage;